import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import "./../../utils/Style/component/login.scss";
import useLoginAPI from "../../api/loginAPI";
import { checkQrStatusTimer, qrTimeoutMinutes } from "../../utils/Constants";
import useValidateToken from '../../authentication/ValidateToken';
import { useDispatch, useSelector } from 'react-redux';



function Barcode() {
    const { isLoading, PortalOnBoard, CheckQrStatus } = useLoginAPI();
    const { checkTokenExpiry } = useValidateToken();
    const [qrUrl, setQrUrl] = useState("");
    const [qrTimeOut, setQrTimeOut] = useState(false);
    const _isMounted = useRef(false);
    var timerStatus;
    const navigate = useNavigate();

    function hasJWT() {
        return !!sessionStorage.getItem("Token");
    }

    const getCode = () => {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('code')) return "";
        return urlParams.get('code');
    }

    useEffect(() => {
        if (getCode()) {
            sessionStorage.setItem("RegCodUrl", getCode());
        }
    }, []);


    const onKeyDown = (e) => {
        if (qrTimeOut && (e.keyCode === 13 || e.keyCode === 32)) {
            PortalOnBoard(setQrTimeOut, setQrUrl);
        }
    }

    const checkToken = async () => await checkTokenExpiry();


    useEffect(() => {
        if (hasJWT()) {
            checkToken().then(() => {
                const role = sessionStorage.getItem("Role");

                if (role === "Arz") {
                    navigate("/overview");
                } else if (role === "Employee") {
                    navigate("/todo");
                }
            }).catch(e => {
                PortalOnBoard(setQrTimeOut, setQrUrl);
            });
        } else {
            PortalOnBoard(setQrTimeOut, setQrUrl);
        }
    }, []);


    useEffect(() => {
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown)
        }
    }, [qrTimeOut])

    useEffect(() => {
        if (!_isMounted.current) {
            _isMounted.current = true;
            return;
        }
        var countDownDate = new Date();
        countDownDate.setMinutes(countDownDate.getMinutes() + qrTimeoutMinutes);
        countDownDate = countDownDate.getTime();

        timerStatus = setInterval(() => {
            var now = new Date().getTime();
            var distance = countDownDate - now;

            if (distance < 0) {
                clearInterval(timerStatus);
                setQrTimeOut(true);
                return;
            }

            if (
                sessionStorage.getItem("SessionID") &&
                sessionStorage.getItem("SessionID").length > 0 &&
                qrUrl.length > 0
            ) {
                CheckQrStatus(timerStatus, setQrTimeOut).catch((e) => {
                    clearInterval(timerStatus);
                    setQrTimeOut(true);
                });
            }
        }, checkQrStatusTimer);


        return () => {
            // 👇️ clear timeout when component unmounts
            clearInterval(timerStatus);
        };
    }, [qrUrl]);


    return (
        <div className='login'>
            <div className='left'>
                <div className='sub_container'>
                    <img className='logo_img' src='/Images/suyool-white.png' alt="" />
                    <div className='title'>Delivery Pickup Portal</div>
                    <div className='desc'>Suyool Delivery Pickup Portal is a web-based platform designed to provide centralized access to a range of
                        company-specific resources and information.
                    </div>
                    <div className='contact'>
                        <div className='txt'><b>Phone:</b> +961 1 290 900</div>
                        <div className="txt"><b>Email:</b> contact@suyool.com</div>
                    </div>
                </div>
            </div>

            <div className='right'>
                <img className='logo-img' src='/Images/suyool-with-logo.png' alt="" />
                <div className='login_account'>
                    Login into Your Account
                </div>
                <div className='scan-text'>Scan QR code</div>
                <div className="qr-cont">
                    {isLoading ? (<img src='/Images/skash_Rocket.gif' className="rocket" alt="loading" />) : (
                        <div className="qr-img" style={{ backgroundImage: `url(${qrUrl})` }}>
                            {qrTimeOut && (
                                <div
                                    className='blue-circle'
                                    // onKeyDown={onKeyDown}
                                    onClick={() => PortalOnBoard(setQrTimeOut, setQrUrl)}
                                >
                                    <div className='blue-circle-inner'>
                                        <img
                                            className='loading-img'
                                            src='/Images/skash_loading.png'
                                            alt='loading'
                                        />
                                        <p>
                                            CLICK TO RELOAD QR CODE
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className='copyrights'>2024 Copyrights © Suyool</div>
            </div>
        </div>
    );
}

export default Barcode;